{
  "You're invited to watch {title}": "Nous vous invitons à regarder {title}",
  "Share your event link": "Partagez le lien de votre événement",
  "device|desktop": "ordinateur",
  "device|phone": "téléphone",
  "device|tablet": "tablette",
  "device|tv": "téléviseur",
  "device|console": "console",
  "{hours}h {minutes}m": "{hours} h {minutes} min",
  "Sorry, there's been an error loading the analytics data.": "Désolés, une erreur s’est produite lors du chargement des statistiques.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "Les statistiques détaillées sont disponibles pour les événements à partir du 20 mai 2025. Voici les statistiques de base de cet événement.",
  "Viewed Live": "Ont regardé en direct",
  "Watched Replay": "Ont regardé la rediffusion",
  "Powered by": "Propulsé par",
  "{count} views": {
    "one": "{count} vue",
    "other": "{count} vues"
  },
  "{count} viewers": {
    "one": "{count} spectateur",
    "other": "{count} spectateurs"
  },
  "Analytics are kept for 100 days. Export a PDF to keep a copy.": "Les statistiques sont conservées 100 jours. Exportez un PDF pour en garder une copie.",
  "Total Views": "Total des vues",
  "Unique Viewers": "Spectateurs uniques",
  "Total Watch Time": "Durée totale de visionnage",
  "Views": "Vues",
  "Watch Time": "Durée de visionnage",
  "Top Countries": "Principaux pays",
  "Top Regions / States": "Principales régions / États",
  "analytics|Unknown": "Inconnu",
  "Device Categories": "Types d’appareils",
  "Top Browsers": "Principaux navigateurs",
  "Operating Systems": "Systèmes d’exploitation",
  "Import": "Importer",
  "Invite a guest": "Inviter une personne",
  "We'll email them the event link and remind them before you go live.": "Nous lui enverrons par e-mail le lien de l’événement, puis un rappel avant votre passage en direct.",
  "CSV Import": "Import CSV",
  "Select File": "Choisir un fichier",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Format : CSV. Colonne obligatoire : « Email ». Colonnes facultatives : « Name », « First Name », « Last Name » (en anglais)",
  "Invite All ({count})": "Inviter tout le monde ({count})",
  "Couldn't load the guest list": "Impossible de charger la liste d’invités",
  "Remove the guest from the list?": "Retirer cette personne de la liste ?",
  "guest status|Joined Live": "A rejoint le direct",
  "guest status|Watched Replay": "A vu la rediffusion",
  "guest status|Visited page": "A visité la page",
  "guest status|Invited": "Invitation envoyée",
  "{count} guest": {
    "one": "{count} invité",
    "other": "{count} invités"
  },
  "Open the guest list": "Ouvrir la liste d’invités",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Les invités de chaque {noun} figurent sur la liste d’invités de {label} (le lien principal). Ils s’inscrivent une seule fois et ont accès à chaque {noun}.",
  "Start inviting guests": "Commencez à inviter",
  "Invite guests by email or just share your event link with them.": "Envoyez des invitations par e-mail ou partagez simplement le lien de votre événement.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Les invités qui signent le livre d’or ou demandent des rappels apparaissent aussi ici.",
  "Share link": "Partager le lien",
  "Download guest list": "Télécharger la liste d’invités",
  "Guests {title}.csv": "Invités {title}.csv",
  "Guests.csv": "Invités.csv",
  "{title}-report.pdf": "{title}-rapport.pdf",
  "analytics-report.pdf": "rapport-statistiques.pdf",
  "Export PDF": "Exporter en PDF",
  "Invitation sent": "Invitation envoyée",
  "{name} will get reminders before you go live.": "{name} recevra des rappels avant votre passage en direct.",
  "Couldn't send the invitation": "Impossible d’envoyer l’invitation",
  "Guest's name": "Nom de l’invité",
  "e.g. Maria Lopez": "Ex. : Marie Dupont",
  "Send invitation": "Envoyer l’invitation",
  "Could not open image library.": "Impossible d’ouvrir la photothèque.",
  "Delete Cover?": "Supprimer l’image de couverture ?",
  "Delete failed": "Échec de la suppression",
  "Processing image...": "Traitement de l’image...",
  "Uploading... {percent}%": "Importation... {percent} %",
  "Invalid file": "Fichier non valide",
  "Only JPG or PNG files are accepted": "Seuls les fichiers JPG ou PNG sont acceptés",
  "Drop image here": "Déposez l’image ici",
  "Drop image here or click to select": "Déposez l’image ici ou cliquez pour la choisir",
  "Recommended size: 1280x720 pixels": "Taille recommandée : 1280x720 pixels",
  "Accepts PNG or JPG under 50MB": "Accepte les PNG ou JPG de moins de 50 Mo",
  "Couldn't save that": "Impossible d’enregistrer",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Les invités qui regardent sur votre site web reçoivent des e-mails avec un lien vers la page depuis laquelle ils ont regardé l’événement.",
  "Pages where guests watch your embed will show up here.": "Les pages où les invités regardent votre Embed s’afficheront ici.",
  "Seen on": "Vu sur",
  "Use for email links": "Utiliser pour les liens des e-mails",
  "Ignore": "Ignorer",
  "Used for email links": "Utilisées pour les liens des e-mails",
  "Stop using": "Ne plus utiliser",
  "Other guests": "Autres invités",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "L’URL de la page web de votre Embed, configurée auparavant. Retirez-la pour envoyer les autres invités vers evt.live.",
  "EventLive event": "Événement EventLive",
  "How this event's page looks to guests. It overrides the branding in your profile.": "L’apparence de la page de cet événement pour les invités. Elle remplace la personnalisation de votre profil.",
  "Could not update branding settings": "Impossible de mettre à jour la personnalisation",
  "Event page": "Page de l’événement",
  "Description": "Description",
  "A few words for your guests": "Quelques mots pour vos invités",
  "Supports Markdown: **bold**, lists and links.": "Markdown pris en charge : **gras**, listes et liens.",
  "e.g. 7pm ET / 4pm PT": "Ex. : 19 h Paris / 13 h Montréal",
  "Replaces the date and time on your event page and in reminder emails.": "Remplace la date et l’heure sur la page de votre événement et dans les e-mails de rappel.",
  "Company": "Entreprise",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Affiché uniquement sur la page de cet événement. PNG ou JPG ; il est recadré et redimensionné automatiquement. Les logos horizontaux donnent le meilleur résultat. Un logo blanc sur fond transparent risque de ne pas se voir sur une page claire.",
  "Put your event page or just the video player on your own website.": "Intégrez la page de votre événement, ou seulement le lecteur vidéo, à votre propre site web.",
  "Layout": "Mise en page",
  "Full embed": "Embed complet",
  "The event page: video, guestbook and reminders.": "La page de l’événement : vidéo, livre d’or et rappels.",
  "Just video": "Vidéo seule",
  "Only the video player.": "Le lecteur vidéo uniquement.",
  "These change the code below. Copy it again after changing them.": "Ces options modifient le code ci-dessous. Copiez-le de nouveau après les avoir modifiées.",
  "Autoplay": "Lecture automatique",
  "Start the video automatically.": "Lance la vidéo automatiquement.",
  "Reminder button": "Bouton de rappel",
  "Guests can sign up for reminders from your website.": "Les invités peuvent s’inscrire aux rappels depuis votre site web.",
  "No replay and no rewind in the embed.": "Ni rediffusion ni retour en arrière dans l’Embed.",
  "Script (recommended)": "Script (recommandé)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Les spectateurs qui ouvrent un lien d’e-mail EventLive sur votre page y sont reconnus, et le lecteur s’adapte à la taille de la page.",
  "Simple iframe (no script)": "Iframe simple (sans script)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Pour les créateurs de sites qui suppriment les scripts. Le lecteur ne voit pas les liens d’e-mail des spectateurs : les détenteurs de billets sur un nouvel appareil devront peut-être se reconnecter.",
  "Embed code": "Code Embed",
  "Copy embed code": "Copier le code Embed",
  "Embed code copied": "Code Embed copié",
  "Paste it into your website's HTML.": "Collez-le dans le HTML de votre site web.",
  "Preview": "Aperçu",
  "Couldn't load the guestbook": "Impossible de charger le livre d’or",
  "Delete this message?": "Supprimer ce message ?",
  "Messaging": "Messagerie",
  "Chat": "Chat",
  "You pinned": "Épinglé par vous",
  "Delete this message": "Supprimer ce message",
  "Could not update messaging settings": "Impossible de mettre à jour les paramètres de messagerie",
  "Guests sign it and add photos. Newest messages first.": "Les invités le signent et ajoutent des photos. Les messages les plus récents en premier.",
  "A live chat next to the video, like a group conversation.": "Un chat en direct à côté de la vidéo, comme une conversation de groupe.",
  "Disable messaging": "Désactiver les messages",
  "Guests can watch but can't post messages.": "Les invités peuvent regarder, mais pas publier de messages.",
  "{count} message": {
    "one": "{count} message",
    "other": "{count} messages"
  },
  "Loading messages…": "Chargement des messages…",
  "No messages yet. They'll appear here as guests post them.": "Aucun message pour l’instant. Ils apparaîtront ici à mesure que les invités les publieront.",
  "Could not update privacy settings": "Impossible de mettre à jour les paramètres de confidentialité",
  "Hide event page": "Masquer la page de l’événement",
  "Manage tickets": "Gérer les billets",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Les invités ont besoin d’un billet pour regarder. Pour offrir l’accès gratuit à certains invités, invitez-les depuis la liste d’invités.",
  "Anyone with the link can watch": "Toute personne disposant du lien peut regarder",
  "Share the link; no password or invitation needed.": "Partagez le lien ; aucun mot de passe ni invitation requis.",
  "Password protected": "Protégé par mot de passe",
  "Guests enter a password you give them.": "Les invités saisissent le mot de passe que vous leur donnez.",
  "Choose a password": "Choisissez un mot de passe",
  "Invite only": "Sur invitation uniquement",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Seuls les invités conviés par e-mail peuvent participer. Un appareil par adresse e-mail à la fois. (DOIVENT figurer sur la <list>liste d’invités</list>)",
  "Ask guests for their name and email": "Demander aux invités leur nom et leur e-mail",
  "Always on for invite-only events.": "Toujours activé pour les événements sur invitation.",
  "Before they can watch. They'll appear in your Guest List.": "Avant de pouvoir regarder. Ils apparaîtront dans votre liste d’invités.",
  "Replay and download": "Rediffusion et téléchargement",
  "Show download link to guests": "Montrer le lien de téléchargement aux invités",
  "Hide viewer counter": "Masquer le compteur de spectateurs",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "La page de votre événement est masquée. Les personnes qui ont acheté un billet ne peuvent pas regarder tant que vous ne la réaffichez pas.",
  "Your event page is hidden. Guests can't open it until you show it again.": "La page de votre événement est masquée. Les invités ne peuvent pas l’ouvrir tant que vous ne la réaffichez pas.",
  "Show event page": "Afficher la page de l’événement",
  "Remove {guest} from the guest list": "Retirer {guest} de la liste d’invités",
  "Message pinned": "Message épinglé",
  "Guests see it at the top of the guestbook.": "Les invités le voient en haut du livre d’or.",
  "Couldn't pin the message": "Impossible d’épingler le message",
  "e.g. Welcome! The ceremony starts at 3 pm.": "Ex. : Bienvenue ! La cérémonie commence à 15 h.",
  "Stays at the top of the guestbook or chat.": "Reste en haut du livre d’or ou du chat.",
  "Pin message": "Épingler le message",
  "Share on {network}": "Partager sur {network}",
  "Share on Email": "Partager par e-mail",
  "Preview my Event Page": "Voir la page de mon événement",
  "Share via:": "Partager via :",
  "Viewer-hours": "Heures de visionnage",
  "{count} viewer-hour": {
    "one": "{count} heure de visionnage",
    "other": "{count} heures de visionnage"
  },
  "Live {live} · Replay {replay}": "En direct {live} · Rediffusion {replay}",
  "Ticketed events have no viewer-hour limit.": "Les événements avec billetterie n’ont pas de limite d’heures de visionnage.",
  "{used} of {limit} viewer-hours included with this event": "{used} sur {limit} heures de visionnage incluses avec cet événement",
  "Over the {limit} viewer-hours included with this event by {over}.": "Dépassement de {over} sur les {limit} heures de visionnage incluses avec cet événement.",
  "By day (UTC)": "Par jour (UTC)",
  "Show fewer days": "Afficher moins de jours",
  "Show all {count} days": {
    "one": "Afficher {count} jour",
    "other": "Afficher les {count} jours"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "Les heures de visionnage sont mises à jour toutes les heures. Elles apparaissent ici dans l’heure qui suit le visionnage.",
  "Live viewers": "Spectateurs en direct",
  "Devices watching each minute of the live stream.": "Appareils connectés à chaque minute de la diffusion en direct.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Spectateurs en direct par minute de {start} à {end}. Pic : {peak} à {time}.",
  "Peak: {count} at {time}": "Pic : {count} à {time}",
  "{count} viewer at {time}": {
    "one": "{count} spectateur à {time}",
    "other": "{count} spectateurs à {time}"
  },
  "Browsers and apps": "Navigateurs et applications",
  "{count} viewer": {
    "one": "{count} spectateur",
    "other": "{count} spectateurs"
  },
  "Regions:": "Régions :",
  "IP Geolocation by DB-IP": "Géolocalisation IP par DB-IP",
  "Before {date}": "Avant le {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "Issues de nos anciennes statistiques, qui ne comptaient que les navigateurs, sauvegardées pour toujours avant leur expiration.",
  "Viewers": "Spectateurs",
  "{live} live · {replay} replay only": "{live} en direct · {replay} uniquement en rediffusion",
  "{time} per viewer": "{time} par spectateur",
  "Peak live viewers": "Pic de spectateurs en direct",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "La durée de visionnage, les vues, les pays et les appareils sont comptés à partir du {date}. Les spectateurs uniques sont comptés pour tous les événements.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Ici, les spectateurs sont des appareils par jour : une personne qui regarde deux jours compte deux fois. Comptés toutes les heures à partir de la vidéo diffusée par notre CDN, sur tous les lecteurs.",
  "Each viewer counts once, however many days they watch. Counted every hour from the video our CDN delivered, on every player.": "Chaque spectateur compte une fois, quel que soit le nombre de jours où il regarde. Comptés toutes les heures à partir de la vidéo diffusée par notre CDN, sur tous les lecteurs.",
  "Mux, for comparison": "Mux, à titre de comparaison",
  "The previous report: the last 100 days, browsers that report to Mux only.": "L’ancien rapport : les 100 derniers jours, uniquement les navigateurs qui transmettent des données à Mux.",
  "analytics|Other": "Autres",
  "Analytics are updated every hour. They show here within an hour of people watching.": "Les statistiques sont mises à jour toutes les heures. Elles apparaissent ici dans l’heure qui suit le visionnage.",
  "Counted from {date}; the viewing before it is further down.": "Décompte à partir du {date} ; le visionnage antérieur figure plus bas.",
  "Counted from {date}; the viewing before it wasn't counted.": "Décompte à partir du {date} ; le visionnage antérieur n’a pas été compté.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "Le visionnage en direct pendant {times} n’est pas entièrement compté : notre réseau vidéo n’a pas conservé tous ses journaux pour cette période.",
  "This event keeps its current report until {date}. Then it moves to our new analytics, which count every player and are kept for good. Export a PDF to keep a copy of this report.": "Cet événement conserve son rapport actuel jusqu’au {date}. Il passera ensuite à nos nouvelles statistiques, qui comptent tous les lecteurs et sont conservées pour toujours. Exportez un PDF pour garder une copie de ce rapport.",
  "Updated hourly.": "Mises à jour toutes les heures.",
  "Last updated {date}, {time}": "Dernière mise à jour : {date}, {time}",
  "analytics|Live": "En direct",
  "analytics|Replay": "Rediffusion"
}
